'use client';

import { useRouter } from 'next/navigation';
import Icon from '@/components/ui/AppIcon';

const CalculatorEmbed = () => {
  const router = useRouter();

  const handleStartCalculator = () => {
    router?.push('/creator-stage-selection');
  };

  return (
    <section className="bg-background py-16 md:py-20">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="bg-gradient-to-br from-primary/10 via-secondary/10 to-accent/10 rounded-2xl p-8 md:p-12 text-center shadow-elevation-3">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary text-primary-foreground mb-6">
              <Icon name="CalculatorIcon" size={20} />
              <span className="caption font-medium">Professional Video Editing Services</span>
            </div>

            <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground mb-4">
              Get Your Custom Plan Now
            </h2>

            <p className="text-lg text-muted-foreground mb-8 max-w-2xl mx-auto">
              Transparent pricing tailored to your content type, editing style, and monthly volume. No hidden fees, no surprises—just professional editing at the right price.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
              <div className="bg-card rounded-lg p-4 border border-border">
                <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center mx-auto mb-3">
                  <Icon name="UserGroupIcon" size={24} className="text-primary" />
                </div>
                <h4 className="font-heading font-semibold text-foreground mb-1">Creator Stage</h4>
                <p className="caption text-muted-foreground">From new to established</p>
              </div>

              <div className="bg-card rounded-lg p-4 border border-border">
                <div className="w-10 h-10 rounded-lg bg-secondary/10 flex items-center justify-center mx-auto mb-3">
                  <Icon name="VideoCameraIcon" size={24} className="text-secondary" />
                </div>
                <h4 className="font-heading font-semibold text-foreground mb-1">Content Type</h4>
                <p className="caption text-muted-foreground">Your video niche</p>
              </div>

              <div className="bg-card rounded-lg p-4 border border-border">
                <div className="w-10 h-10 rounded-lg bg-accent/10 flex items-center justify-center mx-auto mb-3">
                  <Icon name="AdjustmentsHorizontalIcon" size={24} className="text-accent" />
                </div>
                <h4 className="font-heading font-semibold text-foreground mb-1">Editing Style</h4>
                <p className="caption text-muted-foreground">Your preferred look</p>
              </div>
            </div>

            <button
              type="button"
              onClick={handleStartCalculator}
              className="touch-target inline-flex items-center justify-center gap-2 px-10 py-4 rounded-md bg-primary text-primary-foreground font-body font-semibold text-lg transition-smooth hover:shadow-elevation-3 hover:-translate-y-0.5 active:scale-[0.97] focus-ring"
            >
              <Icon name="RocketLaunchIcon" size={24} />
              <span>Start Calculator</span>
              <Icon name="ArrowRightIcon" size={20} />
            </button>

            <p className="caption text-muted-foreground mt-4">
              <Icon name="ClockIcon" size={16} className="inline mr-1" />
              Estimated time: 60 seconds
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CalculatorEmbed;